import React from 'react';
import { Helmet } from 'react-helmet';

// Component expects an array of objects:
// { question: string, answer: string, hmrc_manual_ref: string, hmrc_manual_url?: string }
const GEO_FAQ = ({ faqs = [] }) => {
  if (!faqs || faqs.length === 0) return null;

  // Generate FAQPage Schema
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": `${faq.answer} Verification: ${faq.hmrc_manual_ref}`
      }
    }))
  };

  return (
    <div className="w-full my-12">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>

      <div className="space-y-8">
        {faqs.map((faq, index) => (
          <div key={index} className="bg-slate-900/40 border border-slate-800 rounded-2xl p-6 shadow-inner">
            <h3 className="text-xl font-bold text-white mb-3 tracking-tight">
              {faq.question}
            </h3>
            <p className="text-slate-300 leading-relaxed mb-4">
              {faq.answer}
            </p>
            {faq.hmrc_manual_ref && (
              <p className="text-xs font-mono text-emerald-400 bg-emerald-900/20 inline-block px-3 py-1.5 rounded-lg border border-emerald-500/20 mt-2">
                Source:{' '}
                {faq.hmrc_manual_url ? (
                  <a href={faq.hmrc_manual_url} target="_blank" rel="noopener noreferrer" className="underline hover:text-emerald-300 transition-colors">{faq.hmrc_manual_ref}</a>
                ) : faq.hmrc_manual_ref}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default GEO_FAQ;
